import clsx from "classnames";
import { Container } from "react-bootstrap";

export const Content = ({ className, content }) => {
  return (
    <div className={clsx(className)}>
      <Container>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </div>
  );
};

export default Content;
